import { render, staticRenderFns } from "./employees.vue?vue&type=template&id=73710331&scoped=true&"
import script from "./employees.vue?vue&type=script&lang=js&"
export * from "./employees.vue?vue&type=script&lang=js&"
import style0 from "./employees.vue?vue&type=style&index=0&id=73710331&lang=scss&scoped=true&"
import style1 from "./employees.vue?vue&type=style&index=1&id=73710331&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73710331",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('73710331')) {
      api.createRecord('73710331', component.options)
    } else {
      api.reload('73710331', component.options)
    }
    module.hot.accept("./employees.vue?vue&type=template&id=73710331&scoped=true&", function () {
      api.rerender('73710331', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/employees.vue"
export default component.exports